<script>
import '@assets/css/account-find.css'
import {
  findMemberPassword,
  findMemberPasswordToken,
  findMemberId,
} from '@apis/member'
export default {
  data() {
    return {
      user_id: null,
      email_address: null,
      new_password: null,
      confirm_password: null,
      token: null,
      auth_code: null,
    }
  },
  methods: {
    async handleToken() {
      try {
        const { token } = await findMemberPasswordToken({
          user_id: this.user_id,
          email_address: this.email_address,
        })
        this.$toasted.success(this.$t('toasted_msg.email_auth_send'))
        this.token = token
      } catch (e) {
        this.$toasted.error(e.message)
      }
    },
    handleNewPassword() {
      findMemberPassword({
        token: this.token,
        auth_code: this.auth_code,
        new_password: this.new_password,
        confirm_password: this.confirm_password,
      })
        .catch((e) => this.$toasted.error(e.message))
        .then(() => {
          this.$toasted.success(this.$t('toasted_msg.changed'))
          this.$router.push({ name: 'login-me' })
        })
    },
    handleId() {
      findMemberId({ email_address: this.email_address })
        .catch((e) => this.$toasted.error(e.message))
        .then(() => {
          this.$toasted.success(this.$t('toasted_msg.id_find_mail_send'))
          this.$router.push({ name: 'login-me' })
        })
    },
  },
}
</script>

<template>
  <div class="account-find">
    <div class="container">
      <div v-if="$route.query.type === 'password'" class="box-wrap">
        <div class="go-back">
          <div class="arrow-wrap">
            <router-link :to="{ name: 'login-me' }">
              <img src="@assets/img/longarrow-left-black.svg" alt="화살표" />
            </router-link>
          </div>
          <div class="login-logo pc">
            <img src="@assets/images/v2/logo-full.svg" alt="로고" />
          </div>
          <div class="big-title-wrap">
            <h2 class="big-title">
              {{ $t('find_password') }}
            </h2>
          </div>
        </div>

        <form :class="[$style.inputForm]">
          <template v-if="!token">
            <form @submit.prevent="handleToken">
              <div :class="[$style.formWrap]">
                <label for="user_id" :class="[$style.textLabel]">{{
                  $t('id')
                }}</label>
                <input
                  v-model="user_id"
                  class="marginB-10"
                  :placeholder="$t('id')"
                />
              </div>
              <div :class="[$style.formWrap]">
                <label for="email_address" :class="[$style.textLabel]">{{
                  $t('my_page.email_address')
                }}</label>
                <input
                  v-model="email_address"
                  :placeholder="$t('my_page.email_address')"
                />
              </div>
              <div class="btn-wrap">
                <button class="btn-common-big" native-type="submit">
                  {{ $t('verify') }}
                </button>
              </div>
            </form>
          </template>

          <template v-else>
            <form @submit.prevent="handleNewPassword">
              <div :class="[$style.formWrap]">
                <label for="auth_code" :class="[$style.textLabel]">{{
                  $t('kyc.auth_code')
                }}</label>
                <input v-model="auth_code" :placeholder="$t('kyc.auth_code')" />
              </div>
              <div :class="[$style.formWrap]">
                <label for="new_password" :class="[$style.textLabel]">{{
                  $t('my_page.placeholder_new_password')
                }}</label>
                <input
                  v-model="new_password"
                  class="marginB-10"
                  :placeholder="$t('my_page.placeholder_new_password')"
                  type="password"
                />
              </div>
              <div :class="[$style.formWrap]">
                <label for="confirm_password" :class="[$style.textLabel]">{{
                  $t('confirm_password')
                }}</label>
                <input
                  v-model="confirm_password"
                  :placeholder="$t('confirm_password')"
                  type="password"
                />
              </div>
              <div class="btn-wrap">
                <button class="btn-common-big" native-type="submit">
                  {{ $t('verify') }}
                </button>
              </div>
            </form>
          </template>
        </form>
      </div>
      <div v-else>
        <div class="go-back">
          <div class="arrow-wrap">
            <a @click="$router.go(-1)">
              <img src="@assets/img/longarrow-left-black.svg" alt="뒤로가기" />
            </a>
          </div>
          <div class="login-logo pc">
            <img src="@assets/images/v2/logo-full.svg" alt="로고" />
          </div>
          <div class="big-title-wrap">
            <h2 class="big-title">
              {{ $t('find_id') }}
            </h2>
          </div>
        </div>

        <form :class="[$style.inputForm]" @submit.prevent="handleId">
          <div :class="[$style.formWrap]">
            <label for="email_address" :class="[$style.textLabel]">{{
              $t('my_page.email_address')
            }}</label>
            <input
              v-model="email_address"
              :placeholder="$t('my_page.email_address')"
            />
          </div>
          <div class="btn-wrap">
            <button class="btn-common-big" native-type="submit">
              {{ $t('verify') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.inputForm {
  position: relative;
  box-sizing: border-box;
  padding: 0 !important;
  margin: 0 auto;

  @media (max-width: 768px) {
    .textLabel {
      font-size: 12px;
    }
  }
}

.formWrap {
  position: relative;
  padding-bottom: 20px;
  overflow: hidden;
}

.textLabel {
  display: block;
  padding: 5px 0;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  -webkit-transition: opacity 0.3s ease-in-out;
  transition: opacity 0.3s ease-in-out;

  @media (max-width: 768px) {
    width: 100%;
  }
}
</style>

<style lang="scss">
@import '@design';

.login-logo {
  width: 100%;
  text-align: center;
}
.login-logo img {
  width: 250px;
}
</style>
